import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch } from 'src/client/store'
import type { TypedUseSelectorHook } from 'react-redux'

// Optionally use these instead of 'useDispatch` and `useSelector` to avoid having to manually type them
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<App.State> = useSelector
